import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const fotos = [{
  src: 'https://cdn.magicpatterns.com/uploads/wjiYEHMc4ew2G5nVbpF4mc/Foto_web_grupal.jpg',
  alt: 'Grupo de alumnos y buzos certificados a bordo de la embarcación después de una salida de buceo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rtnp5v4jE6Y8drTK8sp9eg/Foto_web_39.jpg',
  alt: 'Alumnos a bordo de la embarcación de buceo listos para una inmersión'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7E4GjfuTgqQpVBhgC7gDQ2/Foto_web_3.jpg',
  alt: 'Grupo de alumnos en la playa antes de una salida de buceo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7Ngt4q9ZEceM8wP8XHCeAE/Foto_web_38.jpg',
  alt: 'Alumnos y buzos posando en la costa al atardecer tras una inmersión'
}];
export function GaleriaAlumnos() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(0);
  const paginate = (dir: number) => {
    setDirection(dir);
    setCurrent(prev => (prev + dir + fotos.length) % fotos.length);
  };
  const goTo = (i: number) => {
    setDirection(i > current ? 1 : -1);
    setCurrent(i);
  };
  return <div className="max-w-2xl mx-auto" data-id="element-187">
      <div className="relative rounded-3xl overflow-hidden aspect-[3/4] shadow-[0_24px_70px_-25px_rgba(0,0,0,0.7)] bg-brand-dark" data-id="element-188">
        <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-189">
          <motion.img key={current} src={fotos[current].src} alt={fotos[current].alt} custom={direction} initial={(d: number) => ({
          opacity: 0,
          x: d > 0 ? 60 : -60
        })} animate={{
          opacity: 1,
          x: 0
        }} exit={(d: number) => ({
          opacity: 0,
          x: d > 0 ? -60 : 60
        })} transition={{
          duration: 0.4,
          ease: 'easeInOut'
        }} drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.2} onDragEnd={(_, info) => {
          if (info.offset.x < -80) paginate(1);else if (info.offset.x > 80) paginate(-1);
        }} className="absolute inset-0 w-full h-full object-cover object-center cursor-grab active:cursor-grabbing" data-id="element-190" />
        </AnimatePresence>

        {/* Arrows (desktop) */}
        <button onClick={() => paginate(-1)} aria-label="Imagen anterior" className="hidden sm:flex absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-brand-background/60 backdrop-blur-sm border border-white/20 items-center justify-center text-white hover:bg-brand-background/80 transition-colors z-10" data-id="element-191">
          <ChevronLeft size={22} data-id="element-192" />
        </button>
        <button onClick={() => paginate(1)} aria-label="Imagen siguiente" className="hidden sm:flex absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-brand-background/60 backdrop-blur-sm border border-white/20 items-center justify-center text-white hover:bg-brand-background/80 transition-colors z-10" data-id="element-193">
          <ChevronRight size={22} data-id="element-194" />
        </button>
      </div>

      {/* Dots */}
      <div className="flex items-center justify-center gap-2 mt-5" data-id="element-195">
        {fotos.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Ver imagen ${i + 1}`} className={`h-2 rounded-full transition-all duration-300 ${i === current ? 'w-6 bg-brand-primary' : 'w-2 bg-white/30 hover:bg-white/50'}`} data-id="element-196" />)}
      </div>
    </div>;
}